export default __webpack_public_path__ + "static/media/ic-finances.664401d7.svg";